import React, {useEffect, useState} from 'react'
import ProgramUpgradeView from "../../views/ver_24.10/ProgramUpgrade.view";
import {applyPromoCodeService, updateCompanyInfoService} from "../../services/rating.service";
import {PAYMENT_STATUS} from "../../utils/constants";
import Loader from "../../ui_library/ver_24.10/Loader/Loader.comp";
import {useHistory, useParams} from "react-router-dom";
import {getCompanyInfoService} from "../../services/company.service";
import {getAppPaymentService, updateStripeIntentService} from "../../services/app.service";
import {fetchProgramService} from "../../services/program.service";

const ProgramUpgrade = () => {
    const history = useHistory();
    const { programId } = useParams();

    const [showLoader, setShowLoader] = useState(false);
    const [paymentAmount, setPaymentAmount] = useState("");
    const [payment, setPayment] = useState(undefined);
    const [initialAmount, setInitialAmount] = useState(undefined);
    const [paymentFetched, setPaymentFetched] = useState(false);
    const [openDialogue, setOpenDialogue] = useState(false);
    const [isBillingSaved, setIsBillingSaved] = useState(false);
    const [programPaymentStatus, setProgramPaymentStatus] = useState(null);
    const [appliedPromoCode, setAppliedPromoCode] = useState(null);
    const [companyInfo, setCompanyInfo] = useState({});

    async function fetchCreatorProgram() {
        try {
            setShowLoader(true);
            const result = await fetchProgramService(programId);
            if(!result.error && result.data) {
                const {program_state, amount, initial_amount, payment_status} = result.data.existingProgram;
                setProgramPaymentStatus(payment_status);
                setPaymentAmount(amount.toString());
                setInitialAmount(initial_amount.toString());
                setShowLoader(false);
            }
        }
        catch (e) {
            console.error(e)
            setShowLoader(false);
        }
    }

    const getCompanyInfo = async () => {
        try {
            setShowLoader(true);
            const result = await getCompanyInfoService();
            console.log("Company Info Service API: ", result.data.comp);

            if (!result.error && result.data) {
                if (result.data.comp) {
                    setCompanyInfo({
                        NameOrg: result.data.comp.name_org,
                        Region: result.data.comp.region,
                        // sameAsOrgInfo: true,
                        nameCompany: result.data.comp.billing_info && result.data.comp.billing_info.name_org ? result.data.comp.billing_info.name_org : '',
                        addressCompany: result.data.comp.billing_info && result.data.comp.billing_info.address_org ? result.data.comp.billing_info.address_org : '',
                        contactCompany: result.data.comp.billing_info && result.data.comp.billing_info.contact_no_org ? result.data.comp.billing_info.contact_no_org : '',
                        nameContactPerson: result.data.comp.billing_info && result.data.comp.billing_info.name_contact ? result.data.comp.billing_info.name_contact : '',
                        emailContactPerson: result.data.comp.billing_info && result.data.comp.billing_info.email_contact ? result.data.comp.billing_info.email_contact : '',
                        contactContactPerson: result.data.comp.billing_info && result.data.comp.billing_info.contact_no_contact ? result.data.comp.billing_info.contact_no_contact : '',
                    });
                    console.log("companyInfo: ", companyInfo);
                }
            }
        } catch (e) {
            // already toasted the error
            setShowLoader(false);
        } finally {
            setShowLoader(false);
        }
    }

    useEffect(() => {
        fetchCreatorProgram().then((res) => `fetch initiated, ${res}`);
        getCompanyInfo().then((res) => `billing info fetch initiated, ${res}`);
    }, [programId])

    async function loadPayment() {
        const result = await getAppPaymentService(programId);
        if(result.data) {
            const {payment} = result.data;
            setPayment(payment);
            setPaymentFetched(true);
        }
        return true;
    }

    async function updateStripePayment(paymentIntent) {
        const result = await updateStripeIntentService(programId, paymentIntent);
        if(result.data) {
            const {payment} = result.data;
            if(payment.status === PAYMENT_STATUS.SUCCESSFUL) {
                console.log("Payment status", payment.status);
            }
            setPayment(payment)
            setPaymentFetched(true);
        }
        return true;
    }

    function removeUrlParameter(paramKey) {
        const url = window.location.href

        const r = new URL(url)
        r.searchParams.delete(paramKey)
        const newUrl = r.href
        window.history.pushState({ path: newUrl }, '', newUrl)
    }

    useEffect( () => {
        const paymentIntent = new URLSearchParams(window.location.search).get("payment_intent");
        if(paymentIntent) {
            updateStripePayment(paymentIntent).then(() => console.log(`stripe payment updated`)).catch((e) => console.error(`stripe payment update failed, ${e}`))
        } else {
            loadPayment().then(() => console.log(`app payment fetched`)).catch((e) => console.error(`app payment fetch failed, ${e}`))
        }
        removeUrlParameter('payment_intent');
        removeUrlParameter('payment_intent_client_secret')
    }, [])

    useEffect(() => {
        const redirectStatus = new URLSearchParams(window.location.search).get("redirect_status");
        if(redirectStatus) {
            switch (redirectStatus) {
                case "succeeded":
                    console.log("Payment", "Payment successful");
                    break;
                case "processing":
                    console.log("Payment", "Payment is in processing");
                    break;
                case "requires_payment_method":
                    console.log("Payment", "Payment was not successful, try again");
                    break;
                default:
                    console.log("Payment", "Something went wrong");
                    break;
            }
        }
        removeUrlParameter('redirect_status');
    }, [])


    const data = {
        application_id: programId,
        openDialogue,
        payment,
        paymentAmount,
        initialAmount,
        programPaymentStatus,
        paymentFetched,
        isBillingSaved,
        appliedPromoCode,
        companyInfo
    };

    const actions = {
        billingInfoSaveAction : async (values) => {
            try {
                // setShowLoader(true);
                const result = await updateCompanyInfoService(values);
                if (!result.error) {
                    console.log('result.data -> ', result.data);
                    setIsBillingSaved(true);
                    // setShowLoader(false);
                }
            } catch (e) {
                // already toasted the error
                // setShowLoader(false);
            } finally {
                // setShowLoader(false);
            }
        },
        applyPromoCodeAction : async (programId, promo_code) => {
            try {
                setShowLoader(true);
                const result = await applyPromoCodeService(programId, promo_code);
                if (!result.error && result.data) {

                    const {amount, initial_amount, payment_status} = result.data.program_application;
                    setPaymentAmount(amount.toString());
                    setInitialAmount(initial_amount.toString());
                    setProgramPaymentStatus(payment_status);
                    setAppliedPromoCode(promo_code);
                    console.log('result.data -> ', result.data);
                }
            } catch (e) {
                // already toasted the error
                setShowLoader(false);
            } finally {
                setShowLoader(false);
            }
        },
        addFilePathToApplicationDataAction : async (file_path) => {
            try {
                setShowLoader(true);

                setShowLoader(false);
                setOpenDialogue(false);
            }
            catch (e) {
                //already toasted
                setOpenDialogue(false);
                setShowLoader(false);
            }
        },
        handleRedirectDashboardAction: async () => {
            history.push(`/program/${programId}/dashboard`);
        }
    };

    const options = {
        setOpenDialogue : (openDialogue) => {openDialogue ? setOpenDialogue(openDialogue) : setOpenDialogue(false);},
    };

    if (showLoader) {
        return <Loader />;
    }

    return (
        <>
            <div>
                <ProgramUpgradeView
                    data={data}
                    options={options}
                    actions={actions}
                />
            </div>
        </>
    );
}

export default ProgramUpgrade;